import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-bookmark-full",
  templateUrl: "./med-icon-bookmark-full.component.html",
})
export class MedIconBookmarkFullComponent extends SvgMixinComponent {}
